module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-form-preview weui-form-preview"
  }, [_c('div', {
    staticClass: "weui-form-preview__hd"
  }, [_c('label', {
    staticClass: "weui-form-preview__label",
    domProps: {
      "innerHTML": _vm._s(_vm.headerLabel)
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "weui-form-preview__value",
    domProps: {
      "innerHTML": _vm._s(_vm.headerValue || '&nbsp;')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "weui-form-preview__bd"
  }, _vm._l((_vm.bodyItems), function(item) {
    return _c('div', {
      staticClass: "weui-form-preview__item"
    }, [_c('label', {
      staticClass: "weui-form-preview__label"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('span', {
      staticClass: "weui-form-preview__value"
    }, [_vm._v(_vm._s(item.value))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "weui-form-preview__ft"
  }, _vm._l((_vm.footerButtons), function(button) {
    return _c('a', {
      staticClass: "weui-form-preview__btn",
      class: {
        'weui-form-preview__btn_default': button.style === 'default',
        'weui-form-preview__btn_primary': button.style === 'primary'
      },
      attrs: {
        "href": "javascript:"
      },
      on: {
        "click": function($event) {
          return _vm.onButtonClick(button.onButtonClick, button.link)
        }
      }
    }, [_vm._v(_vm._s(button.text))])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e28606ca"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/form-preview/index.vue
// module id = 355
// module chunks = 0